/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBuckwheat = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m5.65 1.748 1.069.529c3.013 1.49 5.386 3.963 6.085 6.433.358 1.265.288 2.596-.472 3.733-.75 1.123-2.058 1.887-3.826 2.276-1.767.39-3.275.246-4.427-.458-1.168-.713-1.79-1.891-1.997-3.19-.404-2.534.71-5.776 2.819-8.394zm.125 3.116c-1.391 2.093-1.967 4.328-1.718 5.893.138.87.513 1.46 1.064 1.798.484.295 1.233.474 2.35.32.327-1.68.057-3.424-.459-5.04a20.774 20.774 0 0 0-1.237-2.97zm3.8 7.386c.536-.277.881-.599 1.094-.917.358-.537.45-1.231.21-2.079-.318-1.128-1.201-2.399-2.506-3.516.193.471.379.97.544 1.488.482 1.508.813 3.242.659 5.024zm9.036-1.879.736.873c1.898 2.253 2.95 5.085 2.64 7.343-.158 1.16-.692 2.235-1.732 2.903-1.026.658-2.371.81-3.935.501-1.564-.308-2.752-.96-3.45-1.958-.71-1.012-.795-2.21-.502-3.343.572-2.206 2.62-4.427 5.231-5.79zm-1.203 2.972c-1.673 1.148-2.785 2.618-3.104 3.849-.185.714-.091 1.273.204 1.694.253.362.739.741 1.616 1 .209-.338.406-.794.58-1.36.253-.828.426-1.792.537-2.75.103-.877.151-1.73.167-2.433zm.841 6.774c.402-.05.703-.168.926-.31.432-.278.732-.76.831-1.49.128-.933-.097-2.151-.673-3.41-.027.357-.061.726-.105 1.101-.12 1.027-.31 2.12-.612 3.103a9.523 9.523 0 0 1-.367 1.006z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBuckwheat as Buckwheat };
